import { pathBuilder } from 'config/paths/index';

export const root = '/admin/company/accesses';
export default pathBuilder(root);
